/**
 * Orders Module
 *
 * Handles order-specific functionality including filters and sorting.
 * Most filter/bulk functionality is handled by core modules (filters.js, bulk-actions.js).
 */

import { $ } from '../utils/dom.js';

const BASE_URL = '/orders';

/**
 * Apply order type filter (preserves sort)
 */
export function applyOrderTypeFilter(select) {
    const orderType = select.value;
    const sortSelect = $('select[onchange="applySortFilter(this)"]');
    const sort = sortSelect?.value || '';

    const params = new URLSearchParams();
    if (orderType) params.append('order_type', orderType);
    if (sort) params.append('sort', sort);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Apply sort filter (preserves order type)
 */
export function applySortFilter(select) {
    const orderTypeSelect = $('select[onchange="applyOrderTypeFilter(this)"]');
    const orderType = orderTypeSelect?.value || '';
    const sort = select.value;

    const params = new URLSearchParams();
    if (orderType) params.append('order_type', orderType);
    if (sort) params.append('sort', sort);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear filters
 */
export function clearFilters() {
    window.location.href = BASE_URL;
}

// Expose globally for legacy onclick handlers
window.applyOrderTypeFilter = applyOrderTypeFilter;
window.applySortFilter = applySortFilter;
window.clearFilters = window.clearFilters || clearFilters;

export default {
    applyOrderTypeFilter,
    applySortFilter,
    clearFilters
};
